import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=3a671be2&scoped=true"
import script from "../js/Main/index.js?vue&type=script&lang=js&external"
export * from "../js/Main/index.js?vue&type=script&lang=js&external"
import style0 from "./MainLayout.vue?vue&type=style&index=0&id=3a671be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a671be2",
  null
  
)

export default component.exports